<template>
  <b-row>
      <b-col cols="12">
        <b-card style="padding:0; overflow-x: hidden;">
          <div>
            <div class="m-2">
              <!-- Table Top -->
              <b-row>
                <!-- Per Page -->
                <b-col
                  cols="12"
                  md="2"
                  class="mb-1 d-flex align-items-center justify-content-start mb-md-0"
                >
                  <label>Show</label>
                  <v-select
                    v-model="perPage1"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="perPageOptions1"
                    :clearable="false"
                    class="mr-1 per-page-selector d-inline-block ml-50"
                  />
                </b-col>

                <b-col sm="12" md="2">
                  <b-form-group>
                      <span>Start Date <strong class="text-danger">*</strong></span>
                    <flat-pickr
                      v-model="start_datetime1"
                      @input="fetchPcc1(true)"
                      class="form-control"
                      :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
                    />
                  </b-form-group>
                </b-col>

                <b-col sm="12" md="2">
                  <b-form-group>
                      <span>End Date <strong class="text-danger">*</strong></span>
                    <flat-pickr
                      v-model="end_datetime1"
                      @input="fetchPcc1(true)"
                      class="form-control"
                      :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
                    />
                  </b-form-group>
                </b-col>

                <b-col sm="12" md="2" class="mt-2">
                  <b-button @click="exportToExcel1(
                        pcc1,
                        ['NIK', 'Name', 'Division', 'Position', 'Count'],
                        ['NIK', 'Name', 'Division', 'Position', 'Count'],
                        ['Visitor Log Count'],
                        formatJson1
                      )" variant="primary"
                      >Export Excel</b-button
                    >
                </b-col>

                <!-- Search -->
                <b-col
                  cols="12"
                  md="4"
                  class="mb-1 d-flex align-items-center justify-content-end mb-md-0"
                >
                  <label class="mr-1">
                    Search
                  </label>
                  <div class="d-flex align-items-center justify-content-end">
                    <b-form-input
                      class="mr-1 d-inline-block"
                      placeholder="Search..."
                      v-model="searchWord1"
                    />
                  </div>
                </b-col>
              </b-row>
            </div>
            <!-- Larger screen than mobile -->
            <div class="d-none d-md-flex flex-column">
              <b-table
                class="w-100 border"
                no-local-sorting
                @sort-changed="sortingChanged1"
                responsive
                striped
                :sort-by.sync="sortBy1"
                :sort-desc.sync="sortDesc1"
                :items="pcc1"
                :fields="pccFields1"
              >
                <template #cell(nik)="item">
                    {{ item.item.IP_ACCESS }}
                </template>
                <template #cell(name)="item">
                    {{ item.item.user ? item.item.user.NAME : '-' }}
                </template>
                <template #cell(division)="item">
                    {{ item.item.user ? item.item.user.DIVISION : '-' }}
                </template>
                <template #cell(position)="item">
                    {{ item.item.user ? item.item.user.JABATAN : '-' }}
                </template>
              </b-table>
              <b-col v-if="isBusy1" class="text-center">
                <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
              </b-col>
            </div>

            <!-- Mobile screen -->
            <div class="d-flex d-md-none flex-column">
              <!-- Loading -->
              <div v-if="isBusy1" class="text-center text-danger my-2">
                <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
                <strong class="text-secondary">Loading...</strong>
              </div>
              <!-- Data -->
              <div v-if="!isBusy1 && pcc1.length == 0" class="text-center text-danger my-2">
                <strong class="text-secondary">No data</strong>
              </div>
              <b-row
                v-if="!isBusy1 && pcc1.length > 0"
                v-for="(item, index) in pcc1"
                :key="item.id"
                class="mb-3 list-item"
              >
                <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
                  <strong class="flex-grow-1 truncate">{{ item.IP_ACCESS }}</strong>
                </b-col>
                <b-col cols="12" class="d-flex flex-wrap">
                  <div style="font-size: 0.75rem;">
                    <p><strong>NAME: </strong>{{ item.user ? item.user.NAME : '-' }}</p>
                    <p><strong>DIVISION: </strong>{{ item.user ? item.user.DIVISION : '-' }}</p>
                    <p><strong>POSITION: </strong>{{ item.user ? item.user.JABATAN : '-' }}</p>
                    <p><strong>COUNT: </strong>{{ item.count }}</p>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted">
                    Showing {{ pagination1.from }} to {{ pagination1.to }} of
                    {{ pagination1.total }} entries
                  </span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >
                  <b-pagination
                    v-model="currentPage1"
                    :total-rows="pagination1.total"
                    :per-page="perPage1"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                    @input="fetchPcc1()"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12">
        <b-card style="padding:0; overflow-x: hidden;">
          <div>
            <div class="m-2">
              <!-- Table Top -->
              <b-row>
                <!-- Per Page -->
                <b-col
                  cols="12"
                  md="2"
                  class="mb-1 d-flex align-items-center justify-content-start mb-md-0"
                >
                  <label>Show</label>
                  <v-select
                    v-model="perPage"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="perPageOptions"
                    :clearable="false"
                    class="mr-1 per-page-selector d-inline-block ml-50"
                  />
                </b-col>

                <b-col sm="12" md="2">
                  <b-form-group>
                      <span>Start Date <strong class="text-danger">*</strong></span>
                    <flat-pickr
                      v-model="start_datetime"
                      @input="fetchPcc(true)"
                      class="form-control"
                      :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
                    />
                  </b-form-group>
                </b-col>

                <b-col sm="12" md="2">
                  <b-form-group>
                      <span>End Date <strong class="text-danger">*</strong></span>
                    <flat-pickr
                      v-model="end_datetime"
                      @input="fetchPcc(true)"
                      class="form-control"
                      :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
                    />
                  </b-form-group>
                </b-col>

                <b-col sm="12" md="2" class="mt-2">
                  <b-button @click="exportToExcel(
                        pcc,
                        ['NIK', 'Name', 'Division', 'Position', 'Date'],
                        ['NIK', 'Name', 'Division', 'Position', 'Date'],
                        ['Visitor Log'],
                        formatJson
                      )" variant="primary"
                      >Export Excel</b-button
                    >
                </b-col>

                <!-- Search -->
                <b-col
                  cols="12"
                  md="4"
                  class="mb-1 d-flex align-items-center justify-content-end mb-md-0"
                >
                  <label class="mr-1">
                    Search
                  </label>
                  <div class="d-flex align-items-center justify-content-end">
                    <b-form-input
                      class="mr-1 d-inline-block"
                      placeholder="Search..."
                      v-model="searchWord"
                    />
                  </div>
                </b-col>
              </b-row>
            </div>
            <!-- Larger screen than mobile -->
            <div class="d-none d-md-flex flex-column">
              <b-table
                class="w-100 border"
                no-local-sorting
                @sort-changed="sortingChanged"
                responsive
                striped
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :items="pcc"
                :fields="pccFields"
              >
                <template #cell(nik)="item">
                    {{ item.item.IP_ACCESS }}
                </template>
                <template #cell(name)="item">
                    {{ item.item.user ? item.item.user.NAME : '-' }}
                </template>
                <template #cell(division)="item">
                    {{ item.item.user ? item.item.user.DIVISION : '-' }}
                </template>
                <template #cell(position)="item">
                    {{ item.item.user ? item.item.user.JABATAN : '-' }}
                </template>
              </b-table>
              <b-col v-if="isBusy" class="text-center">
                <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
              </b-col>
            </div>

            <!-- Mobile screen -->
            <div class="d-flex d-md-none flex-column">
              <!-- Loading -->
              <div v-if="isBusy" class="text-center text-danger my-2">
                <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
                <strong class="text-secondary">Loading...</strong>
              </div>
              <!-- Data -->
              <div v-if="!isBusy && pcc.length == 0" class="text-center text-danger my-2">
                <strong class="text-secondary">No data</strong>
              </div>
              <b-row
                v-if="!isBusy && pcc.length > 0"
                v-for="(item, index) in pcc"
                :key="item.id"
                class="mb-3 list-item"
              >
                <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
                  <strong class="flex-grow-1 truncate">{{ item.IP_ACCESS }}</strong>
                </b-col>
                <b-col cols="12" class="d-flex flex-wrap">
                  <div style="font-size: 0.75rem;">
                    <p><strong>NAME: </strong>{{ item.user ? item.user.NAME : '-' }}</p>
                    <p><strong>DIVISION: </strong>{{ item.user ? item.user.DIVISION : '-' }}</p>
                    <p><strong>POSITION: </strong>{{ item.user ? item.user.JABATAN : '-' }}</p>
                    <p><strong>DATE ACCESS: </strong>{{ $moment(item.DATE_LOGGED).format('Y-MM-DD HH:mm') }}</p>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted">
                    Showing {{ pagination.from }} to {{ pagination.to }} of
                    {{ pagination.total }} entries
                  </span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="pagination.total"
                    :per-page="perPage"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                    @input="changePage"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-card>
      </b-col>
  </b-row>
</template>

<script>
import debounce from 'lodash/debounce'
import VSelect from 'vue-select'
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BFormCheckbox,
  BButton,
  BFormInput,
  BPagination,
  BModal,
  VBModal,
  BFormGroup,
  BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import ParticipantPccTable from '@/views/admin/pcc/ParticipantPCCTable'

export default {
  components: {
    BCard,
    BSpinner,
    BTable,
    BFormCheckbox,
    BFormGroup,
    BButton,
    BRow,
    BCol,
    VSelect,
    BFormInput,
    BPagination,
    BModal,
    flatPickr,
    ParticipantPccTable,
  },

  directives: {
    Ripple,

    VBModal,
  },

  data() {
    return {
      start_datetime:null,
      end_datetime:null,
      sortBy: 'DATE_LOGGED',
      sortDesc: true,
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 30, 'All'],
      pagination: {
        from: 1,
        to: 10,
        total: 0,
      },
      pcc: [],
      pccFields: [
        'nik',
        'name',
        'division',
        'position',
        {
          key: 'DATE_LOGGED',
          formatter: (value, key, item) => {
            return this.$moment(value).format('Y-MM-DD HH:mm')
          },
          label: 'Date Access',
          sortable: true,
        }
      ],
      selectedPCC: '',
      searchWord: '',

      start_datetime1:null,
      end_datetime1:null,
      sortBy1: 'count',
      sortDesc1: true,
      isBusy1: false,
      currentPage1: 1,
      perPage1: 10,
      perPageOptions1: [10, 20, 30, 'All'],
      pagination1: {
        from: 1,
        to: 10,
        total: 0,
      },
      pcc1: [],
      pccFields1: [
        'nik',
        'name',
        'division',
        'position',
        'count'
      ],
      selectedPCC1: '',
      searchWord1: '',
    }
  },

  watch: {
    searchWord(newVal) {
      this.searchByTitle()
    },
    searchWord1(newVal) {
      this.searchByTitle1()
    },
  },

  created() {
    this.start_datetime = this.$moment().startOf('year').format('YYYY-MM-DD');
    this.end_datetime = this.$moment().endOf('year').format('YYYY-MM-DD');
    this.start_datetime1 = this.$moment().startOf('year').format('YYYY-MM-DD');
    this.end_datetime1 = this.$moment().endOf('year').format('YYYY-MM-DD');
    this.fetchPcc()
    this.fetchPcc1()
  },

  methods: {
    fetchPcc(date) {
      this.isBusy = true

      this.$http
        .get('/visitor-log/admin', {
          params: {
            media: "mobile",
            page: date ? 1 : this.currentPage,
            perPage: this.perPage == 'All' ? 9999999 : this.perPage,
            s: this.searchWord.toString().trim(),
            sort: `${this.sortDesc ? '-' : ''}${this.sortBy}`,
            start: this.start_datetime ? this.start_datetime : this.$moment().startOf('year').format('YYYY-MM-DD') ,
            end: this.end_datetime ? this.end_datetime : this.$moment().endOf('year').format('YYYY-MM-DD')
          },
        })
        .then(({ data }) => {
          this.currentPage = data.current_page
          this.pagination.total = data.total
          this.pagination.from = data.from
          this.pagination.to = data.to
          this.pcc = data.data
        })
        .finally(() => {
          this.isBusy = false
        })
    },

    searchByTitle: debounce(function() {
      this.fetchPcc()
    }, 200),

    changePage(page) {
      this.currentPage = page
      this.fetchPcc()
    },

    sortingChanged({ sortBy, sortDesc }) {
      ;(this.sortBy = sortBy), (this.sortDesc = sortDesc)
      this.fetchPcc()
    },

    exportToExcel (records, headers, fieldVal, filename, formatJson) {
      import('@/libs/Export2Excel').then(excel => {
          const list = records
          const data = formatJson(fieldVal, list)
          excel.export_json_to_excel({
            header: headers,
            data,
            filename,
            autoWidth: true,
            bookType: 'xlsx'
          })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        let data = null
        data = v[j]

        if (j === 'Date') {
          data = this.$moment(v.DATE_LOGGED).format('Y-MM-DD HH:mm')
        }

        if (j === 'NIK') {
          data = v.user ? v.IP_ACCESS : ''
        }

        if (j === 'Name') {
          data = v.user ? v.user.NAME : ''
        }

        if (j === 'Division') {
          data = v.user ? v.user.DIVISION : ''
        }

        if (j === 'Position') {
          data = v.user ? v.user.JABATAN : ''
        }

        return data
      }))
    },

    fetchPcc1(date) {
      this.isBusy1 = true
      this.$http
        .get('/visitor-log/admin_top', {
          params: {
            media: "mobile",
            page: date ? 1 : this.currentPage1,
            perPage: this.perPage1 == 'All' ? 9999999 : this.perPage1,
            search: this.searchWord1.toString().trim(),
            sortBy: this.sortBy1,
            start: this.start_datetime1 ? this.start_datetime1 : this.$moment().startOf('year').format('YYYY-MM-DD') ,
            end: this.end_datetime1 ? this.end_datetime1 : this.$moment().endOf('year').format('YYYY-MM-DD')
          },
        })
        .then(({ data }) => {
          this.currentPage1 = data.current_page
          this.pagination1.total = data.total
          this.pagination1.from = data.from
          this.pagination1.to = data.to
          this.pcc1 = data.data
        })
        .finally(() => {
          this.isBusy1 = false
        })
    },

    searchByTitle1: debounce(function() {
      this.fetchPcc1()
    }, 200),

    changePage1(page) {
      this.currentPage1 = page
    },

    sortingChanged1({ sortBy1, sortDesc1 }) {
      ;(this.sortBy1 = sortBy1), (this.sortDesc1 = sortDesc1)
      this.fetchPcc1()
    },
    exportToExcel1 (records, headers, fieldVal, filename, formatJson1) {
      import('@/libs/Export2Excel').then(excel => {
          const list = records
          const data = formatJson1(fieldVal, list)
          excel.export_json_to_excel({
            header: headers,
            data,
            filename,
            autoWidth: true,
            bookType: 'xlsx'
          })
      })
    },
    formatJson1 (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        let data = null
        data = v[j]

        if (j === 'NIK') {
          data = v.user ? v.IP_ACCESS : ''
        }

        if (j === 'Name') {
          data = v.user ? v.user.NAME : ''
        }

        if (j === 'Division') {
          data = v.user ? v.user.DIVISION : ''
        }

        if (j === 'Position') {
          data = v.user ? v.user.JABATAN : ''
        }

        if (j === 'Count') {
          data = v.count
        }

        return data
      }))
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
